import { render, staticRenderFns } from "./CGVU.vue?vue&type=template&id=5b9935ee&"
import script from "./CGVU.vue?vue&type=script&lang=js&"
export * from "./CGVU.vue?vue&type=script&lang=js&"
import style0 from "./CGVU.vue?vue&type=style&index=0&id=5b9935ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports